import { render, staticRenderFns } from "./clientSendNotice.vue?vue&type=template&id=cf173126&scoped=true"
import script from "./clientSendNotice.vue?vue&type=script&lang=js"
export * from "./clientSendNotice.vue?vue&type=script&lang=js"
import style0 from "./clientSendNotice.vue?vue&type=style&index=0&id=cf173126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf173126",
  null
  
)

export default component.exports